<template>
  <footer class="footer-wrap">
    <div class="footer-main">
      <div class="footer-brand">
        <img class="footer-logo" src="../../../assets/img/logo2.png" alt="COG" />
        <p class="footer-desc">
          致力于为主播提供资产评估、数据存证、商业合作 及投融资对接一站式服务，构建主播经济可信生态。
        </p>
      </div>

      <div class="footer-columns">
        <div class="footer-col">
          <h4>产品服务</h4>
          <button type="button" @click="scrollTo('support')">扶持政策</button>
          <button type="button" @click="scrollTo('assets')">数字资产服务</button>
          <button type="button" @click="scrollTo('finance')">金融服务</button>
        </div>

        <div class="footer-col">
          <h4>关于我们</h4>
          <button type="button" @click="gourl()">公司介绍</button>
          <button type="button" @click="scrollTo('intro')">平台介绍</button>
        </div>

        <div class="footer-col">
          <h4>帮助支持</h4>
          <!-- <button type="button" @click="showQrCode">常见问题</button> -->
          <button type="button" @click="showQrCode">联系客服</button>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div>© 四川数字世界文化科技有限公司 版权所有</div>
      <button type="button" class="beian" @click="toBn">蜀ICP备2023022502号-1</button>
    </div>

    <div v-if="qrCodeVisible" class="qr-code-modal" @click.self="qrCodeVisible = false">
      <div class="qr-code-dialog">
        <img :src="dialogLogo" alt="平台标识" class="qr-img" />
        <div class="qr-label">请扫描上方二维码联系我们</div>
        <button class="close-btn" @click="qrCodeVisible = false">关闭</button>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      qrCodeVisible: false,
      dialogLogo: require('../../../assets/img/code.png')
    };
  },
  methods: {
    showQrCode() {
      this.qrCodeVisible = true;
    },
    gourl(url) {
      window.open(url, '_blank');
    },
    toBn() {
      window.open('https://beian.miit.gov.cn/', '_blank');
    },
	gourl(){
		window.open('https://cog.scszsj.com/', '_blank');
	},
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) {
        const navHeight = this.$el && this.$el.offsetHeight ? this.$el.offsetHeight : -120;
        const extraOffsetMap = {
          assets: -200,
          finance: -100,
		  support: -140,
		  intro: -140
        };
        const extraOffset = extraOffsetMap[id] || 0;
        const targetTop = el.getBoundingClientRect().top + window.pageYOffset - navHeight - extraOffset;
    
        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-wrap {
  width: 1200px;
  max-width: calc(100vw - 40px);
  margin: 0 auto;
  padding: 42px 0 24px;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  gap: 60px;
}

.footer-brand {
  width: 360px;
}

.footer-logo {
  width: 273px;
  height: 48px;
}

.footer-desc {
  margin-top: 18px;
  font-size: 12px;
  line-height: 1.9;
  color: #7480a6;
}

.footer-columns {
  display: flex;
  gap: 70px;
}

.footer-col h4 {
  margin-bottom: 18px;
  font-size: 14px;
  color: #1f243f;
}

.footer-col button {
  display: block;
  margin-bottom: 12px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #7884ab;
  font-size: 12px;
  cursor: pointer;
}

.footer-col button:hover,
.beian:hover {
  color: #6c7cff;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  padding-top: 18px;
  border-top: 1px solid #edf0fb;
  font-size: 11px;
  color: #9aa2c0;
}

.beian {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.qr-code-modal {
  position: fixed;
  inset: 0;
  z-index: 2024;
  background: rgba(24, 27, 56, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code-dialog {
  width: 320px;
  padding: 30px 24px 24px;
  border-radius: 20px;
  background: #fff;
  text-align: center;
}

.qr-img {
  width: 180px;
  height: 180px;
}

.qr-label {
  margin-top: 16px;
  color: #545d8d;
  font-size: 14px;
}

.close-btn {
  width: 110px;
  height: 40px;
  margin-top: 18px;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(180deg, #6c7cff 0%, #7962f1 100%);
  color: #fff;
  cursor: pointer;
}

@media (max-width: 900px) {
  .footer-main,
  .footer-columns,
  .footer-bottom {
    display: block;
  }

  .footer-columns {
    margin-top: 24px;
  }

  .footer-col {
    margin-top: 20px;
  }

  .footer-bottom {
    line-height: 1.8;
  }
}
</style>
